import "./selectplan.scss";
import config from "../../app.json";
import axios from "axios";

import { Form, Row, Col } from "react-bootstrap";
import { Context } from "../../Reducers/Store";
import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import ChimpLogin from "../../Assets/Svgs/dark-logo.svg";
import Image from "..//Image/image";
import PlanOption from "../PlanOption/planoption";
import Toggle from "react-toggle";

const SelectPlan = (props) => {
  const { selectPlan, postSelectPlan } = props;
  const [state, dispatch] = useContext(Context);
  const [allPlans, setAllPlans] = useState([]);
  const [periodicity, setPeriodicity] = useState("mo");
  const [myPlan, setMyPlan] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [currentPlanActive, setCurrentPlanActive] = useState(false);
  const [myPlanMonthlyPrice, setMyPlanMonthlyPrice] = useState(null);
  const [toggleMonthly, setToggleMonthly] = useState(false);

  useEffect(() => {
    dispatch({ type: "SET_LOADING", payload: true });
    axios
      .get(config.API_HM + "/profile")
      .then((result) => {
        if (!result.data?.subscription) {
          axios
            .post(config.API_HM + "/subscriptions/invitations/accept", {})
            .then((resultSub) => {
              if (resultSub.status === 200) {
                axios.get(config.API_HM + "/profile").then((result) => {
                  dispatch({ type: "SET_PROFILE", payload: result.data });
                });
              } else {
                setLoaded(true);
              }
            })
            .catch(() => {
              setLoaded(true);
            });
        } else {
          dispatch({ type: "SET_PROFILE", payload: result.data });
          setLoaded(true);
        }

        setMyPlan(result.data?.subscription?.plan);
        setCurrentPlanActive(result.data?.subscription?.active);
      })
      .finally(() => {
        dispatch({ type: "SET_LOADING", payload: false });
      });
  }, [0]);

  useEffect(() => {
    if (state.profile) {
      axios.get(config.API_HM + "/subscriptions/plans").then((result) => {
        const currentPlan = result.data.filter((x) => x.name === myPlan)?.at(0);
        const monthlyPrice = currentPlan?.prices.filter((x) => x.periodicity === "Monthly")?.at(0)?.value ?? 0;
        setMyPlanMonthlyPrice(monthlyPrice);
        setAllPlans(result.data);
      });
    }
  }, [state.profile]);

  // const handleOptionChange = (event) => {
  //   setPeriodicity(event.target.value);
  // };

  const handleOptionChangeToggle = () => {
    const monthly = periodicity === `mo`;
    const newValue = monthly ? `yr` : `mo`;
    setPeriodicity(newValue);
  };

  const handleNotifications = () => {
    setToggleMonthly(!toggleMonthly);
    handleOptionChangeToggle();
  };

  const anyZeroPlan = allPlans?.some((x) => x.prices?.some((y) => y.value === 0));

  const planColumnsSize = allPlans != null && allPlans.length < 3 ?  6 :  Math.floor(12 / allPlans.length);

  return loaded ? (
    <div className={`plan-container  ${selectPlan ? `select-plan` : ``}`}>
      <div className={`logo-subscription`} style={{ display: "flex", justifyContent: "center" }}>
        <Row>
          <Col className="col-md-12">
            <Image src={ChimpLogin} width={200} height={50} />
          </Col>
        </Row>
      </div>
      <div className={`header-subscription`} style={{ display: "flex", justifyContent: "center" }}>
        <Row>
          <Col className="col-md-12">
            <h1>AI made affordable</h1>
            <p>Pricing Plans for every budget</p>
          </Col>
        </Row>
      </div>
      <div>
        { /* Removed yearly options */}
        {/* <Row className="d-flex justify-content-center">
          <div className="notifications-column">
            <div className="form-group">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <span className="monthly-text">Monthly</span>
                <Toggle checked={toggleMonthly} onClick={handleNotifications} className="form-group" icons={false} />
                <span className="yearly-text">Yearly</span>
              </div>
            </div>
          </div>
        </Row> */}
        <Row className="d-flex justify-content-center">
          <Col md={8} className="align-self-center">
            <Row>
              <Col className="col-md-12 ">
                <Row className="gx-0 d-flex justify-content-center">
                  {allPlans?.map((x, index) => {
                    const planMonthlyPrice = x.prices?.filter((x) => x.periodicity === "Monthly")?.at(0)?.value ?? 0;
                    const allowUpdate =
                      selectPlan === true ||
                      myPlan === null ||
                      myPlan === undefined ||
                      !currentPlanActive ||
                      (anyZeroPlan && myPlanMonthlyPrice >= 0 && myPlanMonthlyPrice < planMonthlyPrice) ||
                      (!anyZeroPlan && myPlanMonthlyPrice > 0 && myPlanMonthlyPrice < planMonthlyPrice);

                    const currentPlanSelected = myPlan === x.name;

                    return (
                      <div className={`col-md-${planColumnsSize}`} key={"item_plan_" + index + "_" + x.id}>
                        <PlanOption
                          {...x}
                          freeTrialDays={x.freeTrialDays != null && x.freeTrialDays != undefined ? x.freeTrialDays : 0}
                          periodicity={periodicity}
                          selectPlan={allowUpdate}
                          postSelectPlan={postSelectPlan}
                          requirePost={selectPlan}
                          currentPlan={currentPlanSelected}
                          bestOption={x.popular}
                        />
                      </div>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center features-list" style={{ paddingTop: "32px" }}>
          <Col md={6}>
            <hr style={{ color: "#6C727526" }} />
            <h4 style={{ paddingTop: "32px", paddingBottom: "32px", fontWeight: 700 }}>Core Features</h4> 

            <Row>
              <Col className="col-md-4">&nbsp;</Col>
              <Col className="col-md-4" style={{ fontWeight: 700 }}>Free Plan</Col>
              {/* <Col className="col-md-4" style={{ fontWeight: 700 }}>Base Plan</Col>
              <Col className="col-md-4" style={{ fontWeight: 700 }}>Pro Plan</Col> */}
            </Row>
            <hr style={{ color: "#6C727526" }} />
            <Row style={{
              height: "64px",
              alignItems: "center"
            }}>
              <Col className="col-md-4">Access full to AI capabilities</Col>
              <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col>
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
            </Row>
            <hr style={{ color: "#6C727526" }} />
            <Row style={{
              height: "64px",
              alignItems: "center"
            }}>
              <Col className="col-md-4">Access to documentation</Col>
              <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col>
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
            </Row>
            <hr style={{ color: "#6C727526" }} />
            <Row style={{
              height: "64px",
              alignItems: "center"
            }}>
              <Col className="col-md-4">Enterprise-level support</Col>
              <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col>
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
            </Row>
            <hr style={{ color: "#6C727526" }} />
            <Row style={{
              height: "64px",
              alignItems: "center"
            }}>
              <Col className="col-md-4">Support</Col>
              <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col>
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /><span style={{
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: "-0.01em",
                textAlign: "left",
                paddingLeft: "10px"
              }}>Via email</span></Col> */}
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /><span style={{
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: "-0.01em",
                textAlign: "left",
                paddingLeft: "10px"
              }}>24/7 Via chat</span></Col> */}
            </Row>
            <hr style={{ color: "#6C727526" }} />
            <Row style={{
              height: "64px",
              alignItems: "center"
            }}>
              <Col className="col-md-4">Customizable AI prompts</Col>
              <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#9E9E9E", fontSize: "1em" }} icon={faTimes} /></Col>
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#9E9E9E", fontSize: "1em" }} icon={faTimes} /></Col> */}
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
            </Row>
            <hr style={{ color: "#6C727526" }} />
            <Row style={{
              height: "64px",
              alignItems: "center"
            }}>
              <Col className="col-md-4">Dedicated account manager</Col>
              <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#9E9E9E", fontSize: "1em" }} icon={faTimes} /></Col>
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#9E9E9E", fontSize: "1em" }} icon={faTimes} /></Col> */}
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
            </Row>
            <hr style={{ color: "#6C727526" }} />
            <Row style={{
              height: "64px",
              alignItems: "center"
            }}>
              <Col className="col-md-4">Integration with API’s</Col>
              <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#9E9E9E", fontSize: "1em" }} icon={faTimes} /></Col>
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#9E9E9E", fontSize: "1em" }} icon={faTimes} /></Col> */}
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
            </Row>
            <hr style={{ color: "#6C727526" }} />
            <Row style={{
              height: "64px",
              alignItems: "center"
            }}>
              <Col className="col-md-4">Turbo AI Generation</Col>
              <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#9E9E9E", fontSize: "1em" }} icon={faTimes} /></Col>
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#9E9E9E", fontSize: "1em" }} icon={faTimes} /></Col> */}
              {/* <Col className="col-md-4"><FontAwesomeIcon style={{ color: "#0084FF", fontSize: "1em" }} icon={faCheck} /></Col> */}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  ) : null;
};
export default SelectPlan;
